import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Card,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  withStyles,
} from '@material-ui/core';
import { Pagination } from '@material-ui/lab';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import { useQuery } from 'src/app/hooks/useQuery';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
    whiteSpace: 'nowrap'
  },
  body: {
    fontSize: 14,
    whiteSpace: 'nowrap'
  },
  root: {
    padding: '12px 16px'
  }
}))(TableCell);

const Results = ({
  className,
  totalCustomer,
  listCustomer,
  getListCustomerRef,
  currentParams
}) => {
  const classes = useStyles();
  const [limit, setLimit] = useState(PAGE_SIZE_LIST);
  const [page, setPage] = useState(1);
  const [params, setParams] = useState({
    page: page,
    page_size: limit
  });

  const query = useQuery();

  useEffect(() => {
    if (currentParams) {
      setParams({
        ...currentParams,
        page: currentParams?.page || 1,
        page_size: currentParams?.page_size || PAGE_SIZE_LIST
      });
    }
  }, [currentParams]);

  useEffect(() => {
    const pageFromQuery = query.get('page');
    const pageSizeFromQuery = query.get('page_size');

    if (pageFromQuery) {
      setParams(prev => ({
        ...prev,
        page: Number(pageFromQuery)
      }));
    }
    if (pageSizeFromQuery) {
      setParams(prev => ({
        ...prev,
        page_size: Number(pageSizeFromQuery)
      }));
    }
  }, [query]);

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    if (!getListCustomerRef) return;
    const newParams = {
      ...currentParams,
      page: newPage,
      page_size: limit
    }
    setParams(newParams);
    getListCustomerRef(newParams);
  };

  return (
    <>
      <Card className={clsx(classes.root, className)}>
        <div>
          <PerfectScrollbar>
            {listCustomer && listCustomer.length ? (
              <Box minWidth={1050}>
                <Table>
                  {listCustomer?.length > 0 && (
                    <TableHead>
                      <TableRow>
                        <StyledTableCell width={250}>
                          Tên khách hàng
                        </StyledTableCell>
                        <StyledTableCell width={250}>
                          Số điện thoại
                        </StyledTableCell>
                        <StyledTableCell width={250}>
                          Tên đăng nhập
                        </StyledTableCell>
                        <StyledTableCell width={250}>Địa chỉ</StyledTableCell>
                        <StyledTableCell width={150}>
                          Thiết bị đã kích hoạt
                        </StyledTableCell>
                      </TableRow>
                    </TableHead>
                  )}
                  <TableBody>
                    {listCustomer.map((user) => (
                      <TableRow hover key={user.id}>
                        <StyledTableCell>
                          {user?.full_name || '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {user?.phone || '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {user?.username || '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {user?.address || '-'}
                        </StyledTableCell>
                        <StyledTableCell>
                          {user?.deviceCount || '-'}
                        </StyledTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            ) : (
              <div className="text-center pb-5">
                <img src="/static/empty.png" class="justify-content-center" />
                <h4> Danh sách trống </h4>
              </div>
            )}
          </PerfectScrollbar>
        </div>
      </Card>
      {listCustomer && listCustomer.length > 0 && (
        <div class="mt-3 mr-4 float-right">
          <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '15px'
            }}
          >
            <Typography style={{ fontSize: '14px' }}>
              Tổng: {totalCustomer}
            </Typography>
            <Pagination
              count={Math.ceil(totalCustomer / limit)}
              color='primary'
              size="small"
              onChange={handlePageChange}
              page={Number(params.page)}
              showFirstButton
              showLastButton
            />
          </Box>
        </div>
      )}
    </>
  );
};

Results.propTypes = {
  className: PropTypes.string,
  listAgencies: PropTypes.array.isRequired
};

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    '&.MuiPaper-elevation1': {
      boxShadow: 'none'
    }
  },
  groupAction: {
    display: 'flex',
    alignItems: 'center',
    '& .action': {
      cursor: 'pointer',
      padding: '0 5px',
      '&:hover': {
        color: '#3f51b5'
      }
    }
  },
  minWithColumn: {
    minWidth: '150px'
  }
}));

export default React.memo(Results);
